/* eslint-disable @typescript-eslint/no-explicit-any */
import Button from 'components/Button'
import React, { ChangeEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface IInputUpload {
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

const InputUpload: React.FC<IInputUpload> = (props): JSX.Element => {
  const { t } = useTranslation(['onboarding'])
  const { onChange } = props
  const [xlsxFile, setXlsxFile] = useState<File | undefined>()
  const base = 'con-input-upload'
  return (
    <div>
      <div className={`${base}`}>
        <div className={`${base}__name-button`}>
          <Button
            onClick={() => {
              document.getElementById('input-xlsx-file')?.click()
            }}
            variants={'outline'}
          >
            {t('onboarding:input.upload.browse.file')}
          </Button>
        </div>
        <div className={`${base}__name-input`}>
          <span>{xlsxFile?.name}</span>
        </div>
      </div>
      <input
        accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        type='file'
        id='input-xlsx-file'
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          const target = e.target as HTMLInputElement
          setXlsxFile((target.files as unknown as File[])[0])
          onChange && onChange(e)
        }}
        style={{ display: 'none' }}
      />
    </div>
  )
}

export default InputUpload
